import React from 'react';
import _ from "lodash";

const ShowProductOptions = ({product, truncate = false}) => {

    return (
        <>
            {product?.options?.map((option, index) => (
                <div key={index}
                     className="my-1">
                    {/*<div className="font-bold">{option?.name}</div>*/}
                    <div className="flex justify-start ">
                        <p className="">{_.join(_.split(option?.values?.toString(), ','), ', ')}</p>
                    </div>
                </div>
            ))}

        </>
    )
}

export default ShowProductOptions
